import 'angular';

import '../core/core.module.ajs';

import { downgradeInjectable } from '@angular/upgrade/static';

import { API }                 from './api.constant';
import { ApiService }          from './api.service';
import { CacheService }        from './cache.service';
import { STATUSCODES }         from './api.status-codes.constant';
import { StreamSearchService } from './stream-search.service';

import './websockets/websockets.module.ajs';

angular.module('app-lite.api', [
  'app-lite.core',
  'app-lite.websockets',
]).value('API', API)
  .constant('STATUSCODES', STATUSCODES)
  .service('cacheApi', downgradeInjectable(CacheService))
  .service('streamSearch', downgradeInjectable(StreamSearchService))
  .service('workshopAPI', downgradeInjectable(ApiService));
